"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspect = inspect;
const composerLockFileParser = require("@snyk/composer-lockfile-parser");
const system_deps_1 = require("./system-deps");
const PLUGIN_NAME = 'snyk-php-plugin';
async function inspect(basePath, fileName, options = {}) {
    const systemVersions = (0, system_deps_1.systemDeps)(basePath, options);
    const depsTree = composerLockFileParser.buildDepTreeFromFiles(basePath, fileName, systemVersions, options.dev);
    return Promise.resolve({
        package: depsTree,
        plugin: { name: PLUGIN_NAME, targetFile: fileName },
    });
}
//# sourceMappingURL=index.js.map